import {
  AfterContentInit,
  Component,
  computed,
  contentChild,
  Directive,
  ElementRef,
  inject,
  OnDestroy,
  signal,
} from '@angular/core';
import { isNotBlank } from '@app/utils/string';

@Component({
  selector: 'portal-clear-input',
  standalone: false,
  templateUrl: './clear-input.component.html',
  styles: `
    :host {
      display: inline-block;
      position: relative;
    }

    .clear-icon {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
    }
  `,
})
export class ClearInputComponent {
  input = contentChild(ClearInputDirective);
}

@Directive({
  selector: '[clearInputEl]',
  standalone: false,
})
export class ClearInputDirective implements AfterContentInit, OnDestroy {
  value = signal<string>('');
  hasContent = computed(() => isNotBlank(this.value()));

  private el = inject(ElementRef);

  ngAfterContentInit(): void {
    if (this.el.nativeElement instanceof HTMLInputElement) {
      this.el.nativeElement.addEventListener('input', this.updateValue);
    }
  }

  ngOnDestroy(): void {
    if (this.el.nativeElement instanceof HTMLInputElement) {
      this.el.nativeElement.removeEventListener('input', this.updateValue);
    }
  }

  clear(dispatchNativeEvent: boolean = true): void {
    const el = this.el.nativeElement;

    if (el instanceof HTMLInputElement) {
      el.value = '';

      if (dispatchNativeEvent) {
        const event = new Event('input');
        el.dispatchEvent(event);
      }
    }
  }

  private updateValue = () => {
    this.value.set(this.el.nativeElement.value);
  };
}
